import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On route change: scroll to top, OR scroll to anchor if hash is present.
 * For hash navigation we retry across animation frames so layout has
 * settled (the landing page is tall and renders progressively) before
 * we lock the scroll position.
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }

    let cancelled = false;
    let attempts = 0;
    const NAV_OFFSET = 80; // fixed nav band height

    const tryScroll = () => {
      if (cancelled) return;
      const el = document.querySelector(hash);
      if (el) {
        const top =
          el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET;
        window.scrollTo({ top, behavior: "instant" });
      }
      attempts += 1;
      // Re-pin a few times while the page is still painting tall sections.
      if (attempts < 6) {
        setTimeout(() => requestAnimationFrame(tryScroll), 100);
      }
    };

    // First attempt next frame so React has committed.
    requestAnimationFrame(tryScroll);

    return () => {
      cancelled = true;
    };
  }, [pathname, hash]);

  return null;
};
